// @flow

/**
 * The Section component provides a semantic way of specifying a div with layout properties such as margin and textAlign.
 *
 * Section can be applied in place of div when a gap from other components around it is needed.
 */

import React from 'react';
import type { Node } from 'react';

type Margin = boolean | string;

type Props = {
  className?: string,

  marginTop?: Margin,
  marginBottom?: Margin,

  textAlign?: string,

  children?: Node
};

const Section = (props: Props) => (
    <div
        className={`smk-section ${props.className ? props.className : ''}`}
        style={{
            marginTop: getMargin(props.marginTop),
            marginBottom: getMargin(props.marginBottom),
            textAlign: props.textAlign
        }}
    >
        {props.children}
    </div>
);

Section.defaultProps = {
    className: '',
    marginTop: undefined,
    marginBottom: undefined,
    textAlign: undefined
};

export default Section;

const DEFAULT_MARGIN = '2rem';

const getMargin = (margin: ?Margin) => {
    if (margin === undefined || margin === false) return undefined;
    if (margin === true) {
        return DEFAULT_MARGIN;
    }
    return margin;
};
